export * from './lib/app-portal-ui-app-tile.module'
